var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M65.552 7.414a26.89 26.89 0 01-7.718 2.116 13.475 13.475 0 005.908-7.434 26.898 26.898 0 01-8.532 3.26 13.42 13.42 0 00-9.809-4.243c-7.42 0-13.437 6.016-13.437 13.437 0 1.053.119 2.079.348 3.062-11.167-.56-21.068-5.91-27.696-14.04a13.372 13.372 0 00-1.82 6.756c0 4.662 2.373 8.775 5.978 11.184a13.383 13.383 0 01-6.086-1.68V20c0 6.51 4.63 11.94 10.778 13.176a13.452 13.452 0 01-6.068.23c1.71 5.338 6.672 9.223 12.552 9.331A26.963 26.963 0 013.262 48.49a27.41 27.41 0 01-3.205-.187 38.038 38.038 0 0020.598 6.036c24.716 0 38.23-20.474 38.23-38.231 0-.582-.013-1.162-.038-1.738a27.318 27.318 0 006.705-6.956","fill":"#FFF","fillRule":"evenodd"}));
}

Twitter.defaultProps = {"viewBox":"0 0 66 55"};

module.exports = Twitter;

Twitter.default = Twitter;
